import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from 'App';
import 'assets/scss/paper-dashboard.scss?v=1.3.1';
import {setFavicon} from './utils/setFavicon'; // Adjust path as needed

setFavicon();

document.addEventListener('DOMContentLoaded', setFavicon);

// Create root element
const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);

// Render the application
root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);
